export default __webpack_public_path__ + "static/media/TMX-ANALYTICS-IMG.bb3968ed.png";